import { createBrowserRouter, Navigate } from "react-router-dom";
import RootLayout from "@/layouts/RootLayout";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: "/",
        lazy: async () => {
          const { default: Home } = await import("@/pages/Home");
          return { Component: Home };
        },
      },
      {
        path: "/about",
        lazy: async () => {
          const { default: About } = await import("@/pages/About");
          return { Component: About };
        },
      },
      {
        path: "/portfolio",
        lazy: async () => {
          const { default: Portfolio } = await import("@/pages/Portfolio");
          return { Component: Portfolio };
        },
      },
      {
        path: "/contact",
        lazy: async () => {
          const { default: Contact } = await import("@/pages/Contact");
          return { Component: Contact };
        },
      },
      { path: "/home", element: <Navigate to="/" replace /> },
      {
        path: "*",
        lazy: async () => {
          const { default: NotFound } = await import("@/pages/NotFound");
          return { Component: NotFound };
        },
      },
    ],
  },
]);
